import { render, staticRenderFns } from "./PostalCodeSelectModal.vue?vue&type=template&id=16295b70&scoped=true&"
import script from "./PostalCodeSelectModal.vue?vue&type=script&lang=js&"
export * from "./PostalCodeSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeSelectModal.vue?vue&type=style&index=0&id=16295b70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16295b70",
  null
  
)

export default component.exports